import React, {
  FormEvent, useCallback, useState,
} from "react";
import { SearchInput } from "@trussle/external-components";
import debounce from "lodash.debounce";
import { trackEvent } from "../../../../helpers/analytics";

interface ISearchBarProps {
  searchQuery: string;
  setSearchQuery: (input: string) => void;
  betterV2?: boolean;
}

const SEARCH_DELAY_MS = 500;

export const SearchBar: React.FC<ISearchBarProps> = ({ searchQuery, setSearchQuery, betterV2 }) => {
  const [loading, setLoading] = useState(false);
  const debouncedSetSearchQuery = useCallback(
    debounce((event: any) => {
      setSearchQuery(event.target.value);
      setLoading(false);
    }, SEARCH_DELAY_MS),
    [],
  );

  const onBlur = () => trackEvent("Input lost focus", {
    module: "ArticleSearchSplashPanel",
    element_type: "Input",
    section: "Search Bar",
  });

  const onFocus = () => trackEvent("Input gained focus", {
    module: "ArticleSearchSplashPanel",
    element_type: "Input",
    section: "Search Bar",
  });

  return (
    <form
      action="/"
      method="get"
      autoComplete="off"
      onSubmit={(e: FormEvent) => e.preventDefault()}
    >
      <SearchInput
        inputSize={betterV2 ? "large" : "small"}
        value={searchQuery}
        onInput={(e) => {
          setLoading(true);
          debouncedSetSearchQuery(e);
        }}
        onBlur={onBlur}
        onFocus={onFocus}
        name="s"
        isLoading={loading}
        searchCallback={() => null}
        searchEmptiedCallback={() => setSearchQuery("")}
        type="text"
        placeholder="Search articles"
        theme={betterV2 ? "betterV2" : "default"}
      />
    </form>
  );
};
